/* eslint-disable max-len */
const rattrapageFormula = (element, elearningTarget, elearningAttempts, elearningDuration) => {
  const quizPercent = parseInt(element.percent.toFixed(), 10);
  const unitsPercent = parseInt(element.unitsPercent.toFixed(), 10);
  const timePercent = parseInt(element.time.toFixed(), 10);
  let nbCriterias = 0;
  let quizNote = (quizPercent === 100 || quizPercent >= elearningTarget ? 1 : (quizPercent / elearningTarget)) * 10;
  let unitsNote = (unitsPercent === 100 || unitsPercent >= elearningAttempts ? 1 : (unitsPercent / elearningAttempts)) * 10;
  let timeNote = timePercent >= elearningDuration ? 1 : (timePercent / elearningDuration) * 10;
  if (elearningDuration && elearningDuration > 0) {
    nbCriterias += 1;
  } else {
    timeNote = 0;
  }
  if (elearningTarget && elearningTarget > 0) {
    nbCriterias += 1;
  } else {
    quizNote = 0;
  }
  if (elearningAttempts && elearningAttempts > 0) {
    nbCriterias += 1;
  } else {
    unitsNote = 0;
  }
  let note = (
    (elearningTarget && elearningTarget > 0 ? quizNote : 0)
    + (elearningAttempts && elearningAttempts > 0 ? unitsNote : 0)
    + (elearningDuration && elearningDuration > 0 ? timeNote : 0)
  ) / nbCriterias;
  note *= 100;
  note -= note % 1;
  note /= 100;

  return { note };
};

const flawedRattrapageFormula = (element, elearningTarget, elearningAttempts, elearningDuration, elearningDurationTarget) => {
  const quizPercent = parseInt(element.percent.toFixed(), 10);
  let quizTarget = 0;
  const unitsPercent = parseInt(element.unitsPercent.toFixed(), 10);
  let unitsTarget = 0;
  const timePercent = parseInt(element.time.toFixed(), 10);
  let timeTarget = 0;
  let nbCriterias = 0;
  if (elearningDuration && elearningDuration > 0 && elearningDurationTarget && elearningDurationTarget > 0) {
    nbCriterias += 1;
    timeTarget = parseInt(elearningDuration, 10) * 60;
    timeTarget *= elearningDurationTarget / 100;
  }
  if (elearningTarget && elearningTarget > 0) {
    nbCriterias += 1;
    quizTarget = parseInt(elearningTarget, 10);
  }
  if (elearningAttempts && elearningAttempts > 0) {
    nbCriterias += 1;
    unitsTarget = parseInt(elearningAttempts, 10);
  }
  const quizNote = (quizPercent / quizTarget) * 10 >= 10 ? 10 : (quizPercent / quizTarget) * 10;
  const unitsNote = (unitsPercent / unitsTarget) * 10 >= 10 ? 10 : (unitsPercent / unitsTarget) * 10;
  const timeNote = (timePercent / timeTarget) * 10 >= 10 ? 10 : (timePercent / timeTarget) * 10;
  let note = (
    (elearningTarget && elearningTarget > 0 ? quizNote : 0)
    + (elearningAttempts && elearningAttempts > 0 ? unitsNote : 0)
    + (elearningDuration && elearningDuration > 0 && elearningDurationTarget && elearningDurationTarget > 0 ? timeNote : 0)
  ) / nbCriterias;
  note *= 100;
  note -= note % 1;
  note /= 100;
  return {
    note,
    quizTarget,
    quizPercent,
    unitsPercent,
    unitsTarget,
    timeNote,
  };
};

const successFormula = (element, elearningTarget, elearningAttempts, elearningDuration) => {
  const quizPercent = parseInt(element.percent.toFixed(), 10);
  const unitsPercent = parseInt(element.unitsPercent.toFixed(), 10);
  const timePercent = parseInt(element.time.toFixed(), 10);
  let nbCriterias = 0;
  let quizNote = quizPercent === 100 ? 10 : quizPercent / 10;
  let unitsNote = unitsPercent === 100 ? 10 : unitsPercent / 10;
  let timeNote = timePercent >= elearningDuration ? 10 : (timePercent / elearningDuration) * 10;
  if (elearningDuration && elearningDuration > 0) {
    nbCriterias += 1;
  } else {
    timeNote = 0;
  }
  if (elearningTarget && elearningTarget > 0) {
    nbCriterias += 1;
  } else {
    quizNote = 0;
  }
  if (elearningAttempts && elearningAttempts > 0) {
    nbCriterias += 1;
  } else {
    unitsNote = 0;
  }

  let note = ((quizNote + unitsNote + timeNote) / nbCriterias) + 10;
  note *= 100;
  note -= note % 1;
  note /= 100;

  return { note };
};

const flawedSuccessFormula = (element, elearningTarget, elearningAttempts, elearningDuration, elearningDurationTarget) => {
  const quizPercent = parseInt(element.percent.toFixed(), 10);
  let quizTarget = 0;
  const unitsPercent = parseInt(element.unitsPercent.toFixed(), 10);
  let unitsTarget = 0;
  const timePercent = parseInt(element.time.toFixed(), 10);
  let timeTarget = 0;
  let nbCriterias = 0;
  if (elearningDuration && elearningDuration > 0 && elearningDurationTarget && elearningDurationTarget > 0) {
    nbCriterias += 1;
    timeTarget = parseInt(elearningDuration, 10) * 60;
    timeTarget *= elearningDurationTarget / 100;
  }
  if (elearningTarget && elearningTarget > 0) {
    nbCriterias += 1;
    quizTarget = parseInt(elearningTarget, 10);
  }
  if (elearningAttempts && elearningAttempts > 0) {
    nbCriterias += 1;
    unitsTarget = parseInt(elearningAttempts, 10);
  }
  const quizNote = (quizTarget === 100 ? 1 : ((quizPercent - quizTarget) / (100 - quizTarget))) * 10;
  const unitsNote = (unitsTarget === 100 ? 1 : ((unitsPercent - unitsTarget) / (100 - unitsTarget))) * 10;
  const timeNote = (timeTarget === 100 || timePercent >= timeTarget ? 1 : ((timePercent - timeTarget) / (100 - timeTarget))) * 10;
  let note = (((quizTarget > 0 ? quizNote : 0) + (unitsTarget > 0 ? unitsNote : 0) + (timeTarget > 0 ? timeNote : 0)) / nbCriterias) + 10;

  note *= 100;
  note -= note % 1;
  note /= 100;
  return {
    note,
    quizTarget,
    quizPercent,
    unitsPercent,
    unitsTarget,
    timeNote,
  };
};

const exportsFormulas = {
  rattrapageFormula,
  flawedRattrapageFormula,
  successFormula,
  flawedSuccessFormula,
};

export default exportsFormulas;
